import {
  takeLatest, call, put, cancel, SagaReturnType,
} from 'redux-saga/effects';

import Resource, { ResourceSourceType } from 'app/lib/Resource';
import * as request from 'app/lib/provider/request';
import { select } from 'app/store/utils/saga/effects';
import * as cardActions from 'app/store/nodes/card/actions';
import { IMediaResource, IPageGift } from 'app/store/nodes/card/interfaces';

import * as giftActions from '../actions';

export const config = {
  action: giftActions.cashSelectCard.type,
  method: takeLatest,
};

const loadResource = (resources: ResourceSourceType[]): Promise<void> => new Promise((resolve) => {
  const handleLoaded = () => {
    Resource.removeEventListener(Resource.EVENT.ALL_RESOURCES_LOADED, handleLoaded);
    resolve();
  };
  Resource.addEventListener(Resource.EVENT.ALL_RESOURCES_LOADED, handleLoaded);
  Resource.load([...resources]);
});

const requestSelect = async (uuid: string, giftId: number): Promise<boolean> => {
  const uri = `${process.env.REACT_APP_REST_API_ADDRESS}/api/v1/mobigrams/${uuid}/select_gift_card`;
  const params = {
    method: 'post',
    body: JSON.stringify({
      gift_card_id: giftId,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
  };
  try {
    const json = await fetch(uri, params).then((response) => response.json());
    if (json.error) {
      return false;
    }
  } catch {
    return false;
  }
  return true;
};

interface IRequestGiftDataResult {
  page: IPageGift,
  resource?: IMediaResource,
}

const requestGiftData = async (type: string, param: string, code: string): Promise<IRequestGiftDataResult | null> => {
  let response;
  try {
    response = await request.data(type, param, code);
  } catch {
    return null;
  }
  if (response.error) {
    return null;
  }
  const page = (response?.data?.pages || []).find((item) => item.type === 'PageGift') as IPageGift;
  const data = page?.items?.gift;
  if (!data) {
    return null;
  }
  const resource = response?.data?.resources.find((item) => item.id === (data.image as IMediaResource)?.id);
  return {
    page,
    resource,
  };
};

export function* func(action: giftActions.IGiftCashSelectCard) {
  const uuid = yield* select((state) => state.card?.common?.uuid);
  const identity = yield* select((state) => state.card?.common?.identity);
  const currentPageGift = yield* select((state) => state.card?.pages?.find((item) => item.type === 'PageGift'));

  if (!currentPageGift) {
    yield cancel(); return;
  }

  const isChanged: SagaReturnType<typeof requestSelect> = yield call(() => requestSelect(uuid, action.payload.id));
  if (!isChanged) {
    yield put(giftActions.cashChanging(false));
    yield cancel(); return;
  }

  const giftData: IRequestGiftDataResult = yield call(requestGiftData, identity.type, identity.param, identity.code);
  if (!giftData) {
    yield cancel(); return;
  }
  if (giftData.resource) {
    yield call(loadResource, [giftData.resource]);
  }
  yield put(cardActions.updatePage((currentPageGift as IPageGift).id, giftData.page, giftData.resource ? [giftData.resource] : []));
  yield put(giftActions.cashChanging(false));
}
